import { Show } from "solid-js";
import type { ExerciseType } from "../lib/activity";
import { ICON_PATHS, typeIconKey } from "../lib/exerciseIcons";

interface Props {
  /** Catalog icon key or emoji. Unknown/missing falls back to the type icon. */
  icon?: string | null;
  type?: ExerciseType;
  class?: string;
}

/** Line icon for an exercise: catalog key, emoji, or the default icon of its type. */
export default function ExerciseIcon(props: Props) {
  const key = () => {
    const i = props.icon?.trim();
    if (i && ICON_PATHS[i]) return i;
    return typeIconKey(props.type);
  };
  const emoji = () => {
    const i = props.icon?.trim();
    return i && !ICON_PATHS[i] ? i : null;
  };

  return (
    <Show
      when={emoji()}
      fallback={
        <svg
          class={`ex-icon ${props.class ?? ""}`}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.7"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d={ICON_PATHS[key()]} />
        </svg>
      }
    >
      <span class={`ex-icon ex-icon-emoji ${props.class ?? ""}`} aria-hidden="true">
        {emoji()}
      </span>
    </Show>
  );
}
